import React, { PureComponent } from "react";
import TableContentsLayout from "../../layouts/table-contents";

class TeamReportsSection1Step2 extends PureComponent {
  get left_content() {
    return (
      <span>
        1. Grading & Ranking
        <br />
        2. Financial, Planning, & Analysis
        <br />
        3. Marketing & Sales Analysis
        <br />
        4. Operational Analysis
        <br />
        5. Financing Analysis
      </span>
    );
  }

  get right_content() {
    return (
      <span>
        Let's breakdown your performance
        <br />
        <br />
        In this report, we first cover the metrics that drive your grades/ranks,
        and then analyze each of your core team's performance.
      </span>
    );
  }

  render() {
    return (
      <TableContentsLayout
        title="Table of Contents"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection1Step2;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-1/step-2.js